export const THEME = {
    bg: '#0a0a0a',
    cardBg: '#18181b',
    border: '#333',
    primary: '#2cbb5d',
    primaryHover: '#249a4d',
    secondary: '#a1a1aa',
    accent: '#ef4743',
    textMain: '#ffffff',
    grid: '#222',
};

export const pageBackgroundSx = {
    minHeight: '100vh',
    bgcolor: THEME.bg,
    background: 'linear-gradient(180deg, #0a0a0a 0%, #111 100%)',
    position: 'relative',
};

export const gridOverlaySx = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.05,
    pointerEvents: 'none',
    backgroundImage:
        'linear-gradient(#333 1px, transparent 1px), linear-gradient(90deg, #333 1px, transparent 1px)',
    backgroundSize: '40px 40px',
};
